import React from "react";
import { Box, Typography, Grid } from "@material-ui/core";
import DDUCalloutCard from "./DDUCalloutCard/DDUCalloutCard";
import GrossEarningsCalloutCard from "./GrossEarningsCalloutCard/GrossEarningsCalloutCard";
import NetEarningsCalloutCard from "./NetEarningsCalloutCard/NetEarningsCalloutCard";
import EmployeesCalloutCard from "./EmployeesCalloutCard/EmployeesCalloutCard";
import { DPPermissionGate } from "Components/DP";
import DPCard from "Components/DP/DPCard/DPCard";

const DataExchangeDashboardSection = () => {
  return (
    <DPPermissionGate
      permissionKeys={[
        "canDownloadDirectDepositUpdates",
        "canCreateGrossEarnings",
        "canCreateNetEarnings",
        "canCreateBatchOnboard",
      ]}
    >
      <Grid container direction={"column"} spacing={2} wrap={"nowrap"}>
        <Grid item>
          <Box pt={3}>
            <Typography variant="h1">Data Exchange</Typography>
          </Box>
        </Grid>
        <Grid item>
          <DPCard>
            <DPPermissionGate permissionKeys={["canCreateBatchOnboard"]}>
              <EmployeesCalloutCard />
            </DPPermissionGate>
            <DPPermissionGate permissionKeys={["canCreateGrossEarnings"]}>
              <GrossEarningsCalloutCard />
            </DPPermissionGate>
            <DPPermissionGate permissionKeys={["canCreateNetEarnings"]}>
              <NetEarningsCalloutCard />
            </DPPermissionGate>
            <DPPermissionGate permissionKeys={["canDownloadDirectDepositUpdates"]}>
              <DDUCalloutCard />
            </DPPermissionGate>
          </DPCard>
        </Grid>
      </Grid>
    </DPPermissionGate>
  );
};

export default DataExchangeDashboardSection;
